var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 258.452,
    height: 271.821,
    viewBox: "0 0 258.452 271.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 258.452,
    height: 271.821,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M159.654,224.4a10.557,10.557,0,0,1-3.7-.666A199.749,199.749,0,0,1,109,196.486c-31.542-24.681-48.212-54.852-48.212-87.255v-2.38a10.2,10.2,0,1,1,20.4,0v2.38c0,55.767,62.584,86.935,78.418,93.922,15.807-7.011,78.445-38.318,78.445-93.922V89.359H225.815a10.206,10.206,0,0,1-9.387-6.205l-11.611-27.3-35.85,83.069a10.2,10.2,0,0,1-18.734,0L123.152,76.163l-3.023,7.024a10.2,10.2,0,0,1-9.37,6.171H10.2a10.2,10.2,0,0,1,0-20.4h93.844l9.721-22.6a10.207,10.207,0,0,1,9.364-6.171h.007a10.207,10.207,0,0,1,9.367,6.157l27.1,62.8,35.918-83.226a10.194,10.194,0,0,1,9.367-6.157h.027a10.188,10.188,0,0,1,9.357,6.205l18.292,43h15.691a10.2,10.2,0,0,1,10.2,10.2v30.073c0,32.4-16.674,62.574-48.212,87.255a199.732,199.732,0,0,1-46.961,27.251,10.155,10.155,0,0,1-3.624.666",
    transform: "translate(0 47.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M28.079,109.089a10.2,10.2,0,0,1-10.2-10.2v-65.1a10.2,10.2,0,0,1,5.114-8.843,188.425,188.425,0,0,1,187.4,0,10.2,10.2,0,0,1,5.114,8.84V74.347a10.2,10.2,0,1,1-20.4,0V39.806a168.05,168.05,0,0,0-156.822,0V98.888a10.2,10.2,0,0,1-10.2,10.2",
    transform: "translate(42.91 0)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteShield);
export default __webpack_public_path__ + "static/media/white-shield.05b884d7de707aeb63d0.svg";
export { ForwardRef as ReactComponent };